import React, { useContext } from "react";
import "./App.css";
import FirstStep from "./component/FirstStep";
import SecondStep from "./component/SecondStep";
import ThiredStep from "./component/ThiredStep";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import { multiStepContext } from "./StepContext";
import DisplayData from "./component/DisplayData";
import FourthStep from "./component/FourthStep";

const App = () => {
  const { currentStep, finalData } = useContext(multiStepContext);

  const showStep = (step) => {
    switch (step) {
      case 1:
        return <FirstStep />;
      case 2:
        return <SecondStep />;
      case 3:
        return <ThiredStep />;
      case 4:
        return <FourthStep />;
    }
  };

  return (
    <>
      <div className="containers">
        <div className="leftSide">
          <Stepper
            className="stepper "
            activeStep={currentStep - 1}
            orientation="vertical"
          >
            <Step className="step">
              <StepLabel>
                <div className="info">
                  <span>Step 1</span>
                  <p>Your Info</p>
                </div>
              </StepLabel>
            </Step>
            <Step>
              <StepLabel>
                <div className="info">
                  <span>Step 2</span>
                  <p>Your Info</p>
                </div>
              </StepLabel>
            </Step>
            <Step>
              <StepLabel>
                <div className="info">
                  <span>Step 3</span>
                  <p>Your Info</p>
                </div>
              </StepLabel>
            </Step>

            <Step>
              <StepLabel>
                <div className="info">
                  <span>Step 4</span>
                  <p>Your Info</p>
                </div>
              </StepLabel>
            </Step>
          </Stepper>

        </div>
        <div className="rightSide">{showStep(currentStep)}</div>

        <br />
        <br />
        <br />
        <br />

        <br />
        <br />
      </div>
      {finalData.length > 0 ? <DisplayData /> : ""}
    </>
  );
};

export default App;
